// extracted by mini-css-extract-plugin
export default {"root":"xSiPr","centerWrapperPosition":"uH_lw","title":"BIiUB","description":"AzmTp"};